import React, { Fragment } from 'react'
import moment from 'moment'
import { length } from 'ramda'
import { StyledDateline, StyledLine, StyledDateWrapper, StyledIcon, StyledDate, StyledDateDiff } from './styled'

const Dateline = ({ data }) => {
    const calcPosXDate = (index, length) => (index / (length - 1)) * 100
    const calcPosXDateDiff = (index, length) => ((index / (length - 1)) * 100) - ((100 / (length - 1)) / 2)
    return (
        <StyledDateline>
            <StyledLine>
                {
                    data.map(({ time, icon, number = "" }, index) => (
                        <Fragment
                            key={time}
                        >
                            <StyledDateWrapper
                                key={time}
                                left={`${calcPosXDate(index, length(data))}%`}
                            >
                                <StyledIcon name={icon} number={number}/>
                                <StyledDate>
                                    {moment.unix(time).format('DD.MM')}
                                </StyledDate>
                            </StyledDateWrapper>
                            {
                                index > 0 &&
                                <StyledDateDiff
                                    left={`${calcPosXDateDiff(index, length(data))}%`}
                                >
                                    {`${moment.unix(time).diff(moment.unix(data[index - 1].time), 'days')} d`}
                                </StyledDateDiff>
                            }
                        </Fragment>
                    ))
                }
            </StyledLine>
        </StyledDateline>
    )
}

export default Dateline
